import React from 'react';
import SubscriptionPage from '@/components/subscription/SubscriptionPage';

const Subscription = () => {
  return <SubscriptionPage />;
};

export default Subscription;
